import React from 'react';
import { Container } from '@mui/material';
import { MetaTags } from '../../components/Metatags/Metatags';
import { BuzzBridgeJobDetailsContainer } from '../../components/ScreenContainer/BuzzBridgeContainer/BuzzBridgeJobDetailsContainer';

const BuzzBridgeDetails = () => {
    return (
        <MetaTags description={`BuzzBridge`} title={`BuzzBridge Details | Dashboard`}>
            <Container
                disableGutters
                style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'stretch',
                    width: '100%',
                    minHeight: '100vh',
                }}
                maxWidth={false}
                sx={{ marginLeft: 0, width: '100%', maxWidth: '100%' }}>
                <BuzzBridgeJobDetailsContainer />
            </Container>
        </MetaTags>
    );
};

export { BuzzBridgeDetails };
